"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapshotType = exports.VoteChoicesIndex = exports.VoteChoices = void 0;
var VoteChoices;
(function (VoteChoices) {
    VoteChoices["No"] = "No";
    VoteChoices["Yes"] = "Yes";
})(VoteChoices = exports.VoteChoices || (exports.VoteChoices = {}));
// @note The snapshot-hub API does not accept falsy choices like index `0`.
var VoteChoicesIndex;
(function (VoteChoicesIndex) {
    VoteChoicesIndex[VoteChoicesIndex["Yes"] = 1] = "Yes";
    VoteChoicesIndex[VoteChoicesIndex["No"] = 2] = "No";
})(VoteChoicesIndex = exports.VoteChoicesIndex || (exports.VoteChoicesIndex = {}));
var SnapshotType;
(function (SnapshotType) {
    SnapshotType["draft"] = "draft";
    SnapshotType["proposal"] = "proposal";
    SnapshotType["vote"] = "vote";
})(SnapshotType = exports.SnapshotType || (exports.SnapshotType = {}));
